import { FlowProvider, useNavigationFlow } from "@b2bportal/core-utilities";
import { TenantFlightsRebookSteps } from "@tenant/types";

export enum CoreFlightsRebookSteps {
  SUMMARY = "SUMMARY",
  FLIGHT_DEPARTURE = "FLIGHT_DEPARTURE",
  FLIGHT_RETURN = "FLIGHT_RETURN",
  REVIEW = "REVIEW",
  CONFIRMATION = "CONFIRMATION",
}

export const FlightsRebookSteps = {
  ...CoreFlightsRebookSteps,
  ...TenantFlightsRebookSteps,
} as const;
export type FlightsRebookSteps =
  (typeof FlightsRebookSteps)[keyof typeof FlightsRebookSteps];

export const FlightsRebookNavigationFlowProvider = ({
  children,
  navigationFlow,
}) => {
  return (
    <FlowProvider<FlightsRebookSteps> flow={navigationFlow}>
      {children}
    </FlowProvider>
  );
};

export const useFlightsRebookNavigationFlow = () =>
  useNavigationFlow<FlightsRebookSteps>();
